module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/strong-title@2x_9318744eb4fd3340ce101155b73a323d.png";